var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-button',{attrs:{"type":"is-primary is-outlined","size":"is-large","icon-left":"google"},on:{"click":_vm.attemptGoogleLogin}},[_vm._v(" Sign in with Google ")])
}
var staticRenderFns = []

export { render, staticRenderFns }